var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddressContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location-icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Location"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Location_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.03 1.99978C14.29 2.00978 16.45 2.90978 18.03 4.48978C19.62 6.07978 20.51 8.22978 20.5 10.4598V10.5098C20.44 13.5398 18.74 16.3298 16.62 18.5098C15.42 19.7398 14.09 20.8298 12.64 21.7498C12.25 22.0798 11.68 22.0798 11.29 21.7498C9.14 20.3498 7.24 18.5898 5.7 16.5398C4.35 14.7598 3.58 12.6198 3.5 10.3898C3.52 5.73978 7.34 1.98978 12.03 1.99978ZM12.0298 13.2595C12.7398 13.2595 13.4198 12.9895 13.9198 12.4995C14.4398 11.9895 14.7308 11.3105 14.7308 10.5995C14.7308 9.11945 13.5198 7.92945 12.0298 7.92945C10.5398 7.92945 9.33985 9.11945 9.33985 10.5995C9.33985 12.0605 10.5198 13.2395 11.9998 13.2595H12.0298Z",
    fill: "#1A427D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressContact);
export default __webpack_public_path__ + "static/media/address-contact.d00eaa3e98bb97b39e8e7631669bb25f.svg";
export { ForwardRef as ReactComponent };